import React, { useEffect, useState } from 'react';
import ApplicationService from "../../../../services/ApplicationService/ApplicationService";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import CustomButton from "../../../Button/Button";
import AppCredentialModal from "../../../../home/pages/appCredential/appCredentialModal/AppCredentialModal";
import { useTranslation } from "react-i18next";

function AppCredential({ action }) {
    const [openAppCredential, setOpenAppCredential] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [applicationCredentials, setApplicationCredentials] = useState([]);
    const [application, setApplication] = useState({});
    const [selectedConnectors, setSelectedConnectors] = useState({});

    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.WHATSAPP.APP-CREDENTIAL.';


    useEffect(() => {
        if (action.fields.app_connector?.value) {
            setSelectedConnectors({ "app_connector": action.fields.app_connector.value });
        } else {
            action.fields.app_connector = { value: '', isRequired: true }
        }
        const fetchData = async () => {
            const appCredentials = await getApplicationCredentials(action.application_id).then(r => r);
            if (appCredentials.length) {
                setApplicationCredentials(appCredentials);
            }

            const app = await getApplicationById(action.application_id).then(r => r);
            if (app && app.length) {
                setApplication(app[0]);
            }
        };

        fetchData().then(r => r);

    }, [refresh]);

    const getApplicationCredentials = async (id) => {
        if (id) {
            const response = await ApplicationService.getAppCredentials({ application_id: id });
            if (response && response.status && response.data.length) {
                return response.data;
            }
        }
        return [];
    }

    const getApplicationById = async (id) => {
        if (id) {
            const response = await ApplicationService.getApplications({ id: id });
            if (response && response.status && response.data.length) {
                return response.data;
            }
        }
        return [];
    }

    const handleChangeCredential = (credential_id, name) => {
        if (credential_id) {
            let copyConnectors = { ...selectedConnectors };
            copyConnectors[name] = credential_id;
            setSelectedConnectors(copyConnectors);
            action.fields[name] = { value: credential_id, isRequired: true }
        }
    }

    const cancel = () => {
        setOpenAppCredential(false)
    }

    const afterSave = (t) => {
        setRefresh(t);
        setOpenAppCredential(false);
    }

    return (
        <div className="form-element">
            <div className="credentials">
                <span className="dialog-text">{t(label + "CREDENTIAL")}</span>
                <small className="credential-helper">{t(label + "CREDENTIAL-HELP")}</small>
                <FormControl
                    variant="outlined"
                    style={{ width: "100%" }}
                >
                    <Select
                        labelId="demo-simple-select-outlined-label"
                        style={{
                            backgroundColor: "#fff",
                            height: "40px",
                            fontSize: "12px",
                        }}
                        id="demo-simple-select-outlined"
                        value={selectedConnectors["app_connector"] ? selectedConnectors["app_connector"] : ''}
                        onChange={(e) => handleChangeCredential(e.target.value, "app_connector")}
                    >
                        {applicationCredentials.length > 0 &&
                            applicationCredentials.filter(x => x.application_id === action.application_id).map((cred) => (
                                <MenuItem
                                    key={cred.id}
                                    style={{ fontSize: 12 }}
                                    value={cred.id}
                                >
                                    {cred.name}
                                </MenuItem>
                            ))}
                    </Select>
                </FormControl>
                <div className="add-credential">
                    <CustomButton value={t(label + "NEW-CREDENTIAL")} minWidth={"100%"}
                        onClick={() => setOpenAppCredential(true)} />
                </div>
                {openAppCredential &&
                    <AppCredentialModal selectedApp={application} afterSave={afterSave} cancel={cancel} />}


            </div>
        </div>
    );
}

export default AppCredential;
